/**
 * `/auth/login?error=` に載せるコード。
 * サーバー側のリダイレクト生成とログイン画面の文言を1か所で揃える。
 */
export const LOGIN_ERROR_CODE = {
  NO_TENANT_MEMBERSHIP: "no-tenant-membership",
  TENANT_EXPIRED: "tenant-expired",
  AMBIGUOUS_MEMBERSHIP: "ambiguous-membership",
} as const;

export const MAZRICA_ACCOUNT_SWITCH = {
  queryParam: "switch-account",
  queryValue: "mazrica-sales",
  loginPath: "/auth/login?switch-account=mazrica-sales",
} as const;

export type LoginErrorCode =
  (typeof LOGIN_ERROR_CODE)[keyof typeof LOGIN_ERROR_CODE];
